import React, {
    createContext,
    ReactNode,
    useContext,
    useMemo,
    useState,
} from "react";

import { PaginationContextValues } from "../types/contexts";

const PaginationContext = createContext<PaginationContextValues | null>(null);

export const usePaginationContext = () => {
    const context = useContext(PaginationContext);
    if (!context) {
        throw new Error(
            "usePaginationContext must be used within a PaginationProvider",
        );
    }
    return context;
};

export const PaginationProvider: React.FC<{ children: ReactNode }> = ({
    children,
}) => {
    const [page, setPage] = useState<number>(1);
    const [itemsPerPage, setItemsPerPage] = useState<number>(50);

    const contextValue = useMemo(
        () => ({
            itemsPerPage,
            setItemsPerPage,
            page,
            setPage,
        }),
        [itemsPerPage, page],
    );

    return (
        <PaginationContext.Provider value={contextValue}>
            {children}
        </PaginationContext.Provider>
    );
};
